const TOPICS = [
  { label: '#明星离婚', count: '36.8万讨论', hot: true },
  { label: '#综艺爆料', count: '28.5万讨论', hot: true },
  { label: '#影视路透', count: '22.1万讨论', hot: true },
  { label: '#饭圈动态', count: '19.4万讨论', hot: false },
  { label: '#红毯翻车', count: '17.2万讨论', hot: false },
  { label: '#恋情曝光', count: '15.9万讨论', hot: false },
  { label: '#隐婚生子', count: '14.3万讨论', hot: false },
  { label: '#片场趣闻', count: '12.7万讨论', hot: false },
  { label: '#时尚穿搭', count: '10.5万讨论', hot: false },
  { label: '#经典回顾', count: '8.9万讨论', hot: false },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-3">
            大家都在聊
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热门话题</h2>
          <p className="text-sm text-foreground-500 mt-2">紧跟潮流，不错过任何一个热门标签</p>
        </div>

        <div className="flex flex-wrap gap-3 justify-center">
          {TOPICS.map((t) => (
            <a
              key={t.label}
              href="#topics"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all duration-300 hover:-translate-y-0.5 cursor-pointer ${
                t.hot
                  ? 'bg-primary-50 border-primary-200 hover:bg-primary-100'
                  : 'bg-background-100 border-background-200 hover:bg-background-200'
              }`}
            >
              <span className={`text-sm font-medium whitespace-nowrap ${t.hot ? 'text-primary-700' : 'text-foreground-700'}`}>
                {t.label}
              </span>
              <span className={`text-xs whitespace-nowrap ${t.hot ? 'text-primary-500' : 'text-foreground-400'}`}>
                {t.count}
              </span>
              {t.hot && (
                <span className="flex items-center gap-0.5 text-xs text-primary-500">
                  <i className="ri-fire-fill text-[10px]"></i>
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}